import type { MenuConfig } from '~typings/menu'

import permission, { RESOURCE_CAJA_CHICA } from '@/auth/permissions/modules/cajaChica'
import * as names from '@routes/caja-chica/nombres/transacciones'

const { transacciones } = permission

export default [
    {
        title: 'caja_chica.subopciones.vales_caja',
        resource: RESOURCE_CAJA_CHICA,
        action: transacciones.valesCaja._pem,
        children: [
            {
                title: 'caja_chica.subopciones.vale_caja',
                route: names.ROUTE_VALE_CAJA,
                resource: RESOURCE_CAJA_CHICA,
                action: transacciones.valesCaja.valeCaja,
            },
            {
                title: 'caja_chica.subopciones.aprobacion_vale_caja',
                route: names.ROUTE_APROBAR_VALE_CAJA,
                resource: RESOURCE_CAJA_CHICA,
                action: transacciones.valesCaja.aprobacionValeCaja,
            },
        ],
    },
    {
        title: 'caja_chica.subopciones.reposiciones',
        resource: RESOURCE_CAJA_CHICA,
        action: transacciones.reposicionesCaja._pem,
        children: [
            {
                title: 'caja_chica.subopciones.reposicion',
                route: names.ROUTE_REPOSICION_CAJA_CHICA,
                resource: RESOURCE_CAJA_CHICA,
                action: transacciones.reposicionesCaja.reposicionCaja,
            },
        ],
    },
] as MenuConfig[]
